import React, { Component } from "react";
import myPic from "../images/selfpic.jpeg";

export default class About extends Component {
  render() {
    return (
      <>
        <section
          className="ftco-section img ftco-about ftco-no-pt ftco-no-pb"
          id="about-section"
        >
          <div className="container">
            <div className="row d-flex no-gutters">
              <div className="col-md-6 col-lg-6 d-flex">
                <div className="img-about img d-flex align-items-stretch">
                  <div className="overlay"></div>
                  <div
                    className="img d-flex align-self-stretch align-items-center"
                    style={{
                      backgroundImage: `url(${myPic})`,
                      backgroundSize: "400px",
                    }}
                  ></div>
                </div>
              </div>
              <div className="col-md-6 col-lg-6 pl-md-5 py-5">
                <div className="row justify-content-start pb-3">
                  <div className="col-md-12 heading-section ftco-animate">
                    <h1 className="big">About</h1>
                    <h2 className="mb-4">About Me</h2>
                    <p>Software Engineer</p>
                    <ul className="about-info mt-4 px-md-0 px-2">
                      <li className="d-flex">
                        <span>Name:</span> <span>Tongil Kim</span>
                      </li>
                      <li className="d-flex">
                        <span>Address:</span> <span>Seoul, South Of Korea</span>
                      </li>
                      <li className="d-flex">
                        <span>Email:</span> <span>kkimtt1234@gmail.com</span>
                      </li>
                      <li className="d-flex">
                        <span>Blog: </span>{" "}
                        <a
                          href="https://tong12dev.tistory.com/"
                          target="_blank"
                        >
                          Blog - Tongil Kim
                        </a>
                      </li>
                      <li className="d-flex">
                        <span>Github: </span>{" "}
                        <a href="https://github.com/TongilKim" target="_blank">
                          GitHub - Tongil Kim
                        </a>
                      </li>
                      <li className="d-flex">
                        <span>Linkedin: </span>{" "}
                        <a
                          href="https://www.linkedin.com/in/kim-tongil-1a869b164/"
                          target="_blank"
                        >
                          LinkdeIn - Tongil Kim
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="counter-wrap ftco-animate d-flex mt-md-3">
                  <div className="text">
                    <p className="mb-4">
                      <span className="number" data-number="120">
                        3{" "}
                      </span>
                      <span>Projects completed</span>
                    </p>
                    <div className="about-info mt-4 px-md-0 px-2"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}
